import { Link } from "react-router-dom";

const Cart = () => {
  return (
    <>
      <div
        className="inner-banner banner"
        style={{ background: 'url("images/product-banner.jpg")' }}
      >
        <div className="container">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-45">Cart</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="index-2.html">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/new-arrivals">Product</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Cart{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="main-section cart-page border-bottom">
        <div className="container">
          <div className="table-container">
            <table id="cart" className="table table-hover table-condensed">
              <thead>
                <tr>
                  <th style={{ width: "50%" }}>Product</th>
                  <th style={{ width: "10%" }}>Price</th>
                  <th style={{ width: "8%" }}>Quantity</th>
                  <th style={{ width: "22%" }} className="text-center">
                    Subtotal
                  </th>
                  <th style={{ width: "10%" }} />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td data-th="Product">
                    <div className="row">
                      <div className="col-lg-3 col-sm-3 col-xs-6">
                        <img
                          src="images/kasmiri.jpg"
                          alt="Product"
                          className="img-responsive"
                        />
                      </div>
                      <div className="col-lg-9 col-sm-9 col-xs-6">
                        <span className="sm-btn bg-green text-white mb-2">
                          Available online
                        </span>
                        <h4 className="nomargin fs-16 mb-1">
                          Astron Cotton Blended Regular Tops -{" "}
                        </h4>
                        <div className="prd-size">
                          <p className="wow fadeInUp mb-0">Size: Medium</p>
                          <p className="wow fadeInUp mb-0">Color: Black</p>
                          <p className="wow fadeInUp mb-0">
                            <a href="#" className="link">
                              Change
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td data-th="Price"> $30.00</td>
                  <td data-th="Quantity">
                    <input
                      type="number"
                      className="form-control text-center"
                      defaultValue={1}
                    />
                  </td>
                  <td data-th="Subtotal" className="text-center">
                    {" "}
                    $30.00
                  </td>
                  <td className="actions" data-th="Delete">
                    <button className="btn">
                      <i className="mbri-trash" />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td data-th="Product">
                    <div className="row">
                      <div className="col-lg-3 col-sm-3 col-xs-6">
                        <img
                          src="images/prd-2.jpg"
                          alt="Product"
                          className="img-responsive"
                        />
                      </div>
                      <div className="col-lg-9 col-sm-9 col-xs-6">
                        <span className="sm-btn bg-green text-white mb-2">
                          Available online
                        </span>
                        <h4 className="nomargin fs-16 mb-1">
                          Astron Cotton Blended Regular Tops -{" "}
                        </h4>
                        <div className="prd-size">
                          <p className="wow fadeInUp mb-0">Size: Medium</p>
                          <p className="wow fadeInUp mb-0">Color: Black</p>
                          <p className="wow fadeInUp mb-0">
                            <a href="#" className="link">
                              Change
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td data-th="Price"> $30.00</td>
                  <td data-th="Quantity">
                    <input
                      type="number"
                      className="form-control text-center"
                      defaultValue={1}
                    />
                  </td>
                  <td data-th="Subtotal" className="text-center">
                    {" "}
                    $30.00
                  </td>
                  <td className="actions" data-th="Delete">
                    <button className="btn">
                      <i className="mbri-trash" />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td data-th="Product">
                    <div className="row">
                      <div className="col-lg-3 col-sm-3 col-xs-6">
                        <img
                          src="images/prd-3.jpg"
                          alt="Product"
                          className="img-responsive"
                        />
                      </div>
                      <div className="col-lg-9 col-sm-9 col-xs-6">
                        <span className="sm-btn bg-green text-white mb-2">
                          Available online
                        </span>
                        <h4 className="nomargin fs-16 mb-1">
                          Astron Cotton Blended Regular Tops -{" "}
                        </h4>
                        <div className="prd-size">
                          <p className="wow fadeInUp mb-0">Size: Medium</p>
                          <p className="wow fadeInUp mb-0">Color: Black</p>
                          <p className="wow fadeInUp mb-0">
                            <a href="#" className="link">
                              Change
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td data-th="Price"> $30.00</td>
                  <td data-th="Quantity">
                    <input
                      type="number"
                      className="form-control text-center"
                      defaultValue={1}
                    />
                  </td>
                  <td data-th="Subtotal" className="text-center">
                    {" "}
                    $30.00
                  </td>
                  <td className="actions" data-th="Delete">
                    <button className="btn">
                      <i className="mbri-trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row bg-white rounded shadow-sm checkout-container">
            <div className="col-lg-6">
              <div className="bg-light rounded-pill px-4 py-3 text-uppercase font-weight-bold">
                Coupon code
              </div>
              <div className="p-4">
                <p className="font-italic mb-4">
                  On the off chance that you have a coupon code, kindly enter it
                  in the crate beneath
                </p>
                <div className="input-group mb-4 border rounded-pill p-2">
                  <input
                    type="text"
                    placeholder="Apply coupon"
                    aria-describedby="button-addon3"
                    className="form-control border-0"
                  />
                  <div className="input-group-append border-0">
                    <button
                      id="button-addon3"
                      type="button"
                      className="btn btn-dark px-4 rounded-pill"
                    >
                      {" "}
                      <i className="mbri-gift mr-2" />
                      Apply coupon
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="bg-light rounded-pill px-4 py-3 text-uppercase font-weight-bold">
                Order summary{" "}
              </div>
              <div className="p-4">
                <p className="font-italic mb-4">
                  {" "}
                  Bundle and extra expenses are determined in light of values
                  you have entered.
                </p>
                <ul className="list-unstyled mb-4">
                  <li className="d-flex justify-content-between py-3 border-bottom">
                    <strong className="text-muted">Order Subtotal </strong>
                    <strong> $90.00</strong>
                  </li>
                  <li className="d-flex justify-content-between py-3 border-bottom">
                    <strong className="text-muted">Tax</strong>
                    <strong> $10.00</strong>
                  </li>
                  <li className="d-flex justify-content-between py-3 border-bottom">
                    <strong className="text-muted">Total</strong>
                    <h5 className="font-weight-bold"> $100.00</h5>
                  </li>
                </ul>
                <a href="checkout.html" className="btn">
                  <span className="mbri-credit-card mr-2" /> Procceed to
                  checkout
                </a>
              </div>
              <div className="payment-secure text-right">
                <img src="images/paypal.jpg" alt="Payment Secure" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
